export class AbstractTO {
    constructor(public id: number = -1) {
    }
}
